import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Button, Message, Form, Input } from 'semantic-ui-react'
import UserArea from '../Users/UserArea';

import navig_model from 'models/navig_model'

/*
const steps = {
	"0start": { 
		"Q": "How can we help you?",
		"A": [
				{ "text": "I am sick", "value": "sick" },
				{ "text": "I need medication", "value": "med" },
				{ "text": "I want to talk to a doctor", "value": "doc" },
				{ "text": "I need a health test/check", "value": "check" },
				{ "text": "I need a referral to a specialist", "value": "specref" },
				{ "text": "My family member is sick", "value": "sick-fam" },
				{ "text": "Other", "value": "other" },
				{ "text": "I can't find what I need", "value": "https://help.wewordle.com/en/", "link": "true", "ext": "true" }
			]
		},
	"sick": { 
		"Q": "How can we help you?",
		"A": [
				{ "text": "I need a medical certificate", "value": "cert" },
				{ "text": "I want to speak to a doctor", "value": "doc" },
				{ "text": "I need a script for medication", "value": "med" },
				{ "text": "I need a blood test", "value": "check" }
			]
		},
	"med": { 
		"Q": "Do you know the medication you need?",
		"A": [
				{ "text": "Search for medications we offer via online prescription in our catalogue", "value": "/cat", "link": "true" },
				{ "text": "Want to know more about how online prescriptions work?", "value": "/online-scripts/", "link": "true" },
				{ "text": "Speak to a doctor about your medical needs via a telehealth consultation", "value": "/telehealth-consultations", "link": "true" }
			]
		},
	"cert": { 
		"Q": "What certificate do you need?",
		"A": [
				{ "text": "For a single day", "value": "app-cert" },
				{ "text": "For multiple days", "value": "/m/pharm/DocCons/DocConsCov", "name": "doctor consultation", "login": "true" },
				{ "text": "Want more info about our medical certificates?", "value": "/online-medical-certificates", "link": "true" }
			]
		},
	"app-cert": { 
		"Q": "What certificate do you need?",
		"A": [
				{ "text": "For work", "value": "/m/pharm/certs/med-cert", "name": "medical certificate", "login": "true" },
				{ "text": "For school or uni", "value": "/m/pharm/certs/med-cert-school", "name": "medical certificate", "login": "true" },
				{ "text": "For carer's leave", "value": "/m/pharm/certs/med-carer", "name": "medical certificate", "login": "true" }
			]
		},
	"doc": { 
		"Q": "Why do you need to talk to a doctor?",
		"A": [
				{ "text": "Do you require medical advice or a script for medication you have not previously used?", "value": "/cat/DocCons", "link": "true" },
				{ "text": "Do you require a script for medication you have had before?", "value": "med"},
				{ "text": "Do you require the COVID-19 antivirals treatment?", "value": "/covid-antivirals-1", "link": "true" },
				{ "text": "Do you require the weightloss doctor consultation?", "value": "/weight-loss", "link": "true" },
				{ "text": "Do you need a Mental Health Care Treatment Plan?", "value": "/mental-health-care-plans", "link": "true" },
				{ "text": "Want to know more about how our telehealth consultations work?", "value": "/telehealth-consultations", "link": "true" }
			]
		},
	"check": { 
		"Q": "What would you like to check?",
		"A": [
				{ "text": "Want to view the range of tests we offer?", "value": "/c/patho", "link": "true" },
				{ "text": "Want to know more about the tests we offer?", "value": "/online-pathology-requests/", "link": "true" },
				{ "text": "Do you need an STI Test?", "value": "/sti-test-online/", "link": "true" },
				{ "text": "Do you need a COVID-19 PCR Test?", "value": "/covid-pcr-test/", "link": "true" },
				{ "text": "Want to talk to a doctor about a health concern?", "value": "/telehealth-consultations/", "link": "true" }
			]
		},
	"specref": { 
		"Q": "What referral do you need?",
		"A": [
				{ "text": "For a dermatologist (skin)", "value": "ref-derm" },
				{ "text": "For an ophthalmologist (eyes)", "value": "ref-oph" },
				{ "text": "For a gatroenterologist (colonoscopy)", "value": "ref-gast" },
				{ "text": "Other specialist", "value": "/telehealth-consultations", "link": "true" },
				{ "text": "Want to know more about specialist referrals?", "value": "/online-specialist-referrals/", "link": "true" }
			]
		},
	"sick-fam": { 
		"Q": "Select one of the options:",
		"A": [
				{ "text": "Is it a child?", "value": "/childrens-doctor-online", "link": "true" },
				{ "text": "Another relative?", "value": "/telehealth-consultations", "link": "true" }
			]
		},
	"ref-derm": { 
		"Q": "Why do you need to see dermatologist?",
		"A": [
				{ "text": "For acne", "value": "/m/pharm/express-specialist-referrals/referral-dermatology-acne", "name": "dermatology referral", "login": "true" },
				{ "text": "For a generic mole check", "value": "/m/pharm/express-specialist-referrals/referral-dermatology-mole", "name": "dermatology referral", "login": "true" },
				{ "text": "Other", "value": "/cat/DocCons", "link": "true" }
			]
		},
	"ref-oph": { 
		"Q": "Why do you need to see ophthalmologist?",
		"A": [
				{ "text": "For age related macular generation", "value": "/m/pharm/express-specialist-referrals/referral-opthalmologist-macular", "name": "ophthalmologist referral", "login": "true" },
				{ "text": "For cataracts", "value": "/m/pharm/express-specialist-referrals/referral-opthalmologist-cataracts", "name": "ophthalmologist referral", "login": "true" },
				{ "text": "For diabetes", "value": "/m/pharm/express-specialist-referrals/referral-opthalmologist-diabetes", "name": "ophthalmologist referral", "login": "true" },
				{ "text": "For glaucoma", "value": "/m/pharm/express-specialist-referrals/referral-opthalmologist-glaucoma", "name": "ophthalmologist referral", "login": "true" },
				{ "text": "Other", "value": "/cat/DocCons", "login": "true" }
			]
		},
	"ref-gast": { 
		"Q": "Why do you need to see gatroenterologist?",
		"A": [
				{ "text": "Over 50 and require an initial screen?", "value": "/m/pharm/express-specialist-referrals/referral-colonoscopy-initial", "name": "colonoscopy referral", "login": "true" },
				{ "text": "For a 3-5 year check-up?", "value": "/m/pharm/express-specialist-referrals/referral-colonoscopy-followup", "name": "colonoscopy referral", "login": "true" },
				{ "text": "Other", "value": "/cat/DocCons", "login": "true" }
			]
		},
	"other": { 
		"Q": "Select one of the options:",
		"A": [
				{ "text": "I need help managing my weight", "value": "/weight-loss", "link": "true" },
				{ "text": "I want to regrow my hair", "value": "/mens-hair-loss", "link": "true" },
				{ "text": "I want to quit smoking", "value": "/smoking", "link": "true" },
				{ "text": "I need mental health support", "value": "/mental-health-services/", "link": "true" }
			]
		}
}
*/

//	------------------------	------------------------	------------------------

const ProdsNavig = () => {
	const [step, setStep] = useState('0start');
	const [name, setName] = useState();
	const [prev, setPrev] = useState([]);
	const [navig_data, setNavig_data] = useState();
	// const [srch, setSrch]= useState();

	const start = step === '0start', login = step === 'login', search = step === 'search';

	//	------------------------	------------------------	------------------------

	const handleClick = (val, l, n, s) => {
		const next = l && 'login' || s && 'search' || val;
		if(l) {
			app.goto_after_login = val;
			setName(n);
		}
		setPrev([...prev, step]);
		setStep(next);
	}

	const handlePrev = () => {
		setStep(prev[prev.length -1]);
		setPrev(prev.slice(0, -1));
	}
	
	//	------------------------	------------------------	------------------------

	useEffect(()=>{
		const handKeyUp = (evt) => (evt.keyCode === 27) && app.history.push("/")
		window.addEventListener ("keyup", handKeyUp);
		return () => window.removeEventListener ("keyup", handKeyUp)
	},[])

	// 		--------------------------------		--------------------------------		---------

	useEffect(()=>{
		navig_model.watch_record( '', d => setNavig_data(d) )
		// setNavig_data(steps)
	},[])

	//	------------------------	------------------------	------------------------

	return <div className={`quiz-body bg-is-blue h-full w-full pb-24 flex flex-col justify-center`}>
		
		<Message className="quiz-header flex justify-between p-2 h-[64px]"
			onDismiss={() => app.history.push("/")}
			header={<>{!start && <Button onClick={() => handlePrev()}>Previous</Button>}</>}
			/>

		<h1 className="text-white text-center">{navig_data?.[step]?.Q ||  (start || step == 'sick') && 'What would you like to play?' || login && 'Log in or create an account' || step == 'med' && 'What game mode do you want?' || 'Select one of the options:'} </h1>
		{login && <p className="text-white text-center mt-4 sm:mb-10 md:mb-0 mx-4 text-[1.37rem]">A user account is required to play {name}</p>}

		<div className='quiz-content flex items-start justify-center min-h-[250px] sm:mt-10 mb-12 sm:mb-20'>
			<Form.Group widths='equal' className={`${search && 'lg:w-[1074px] mx-4 lg:mx-auto' || 'sm:w-[420px] lg:w-[500px] mx-4 sm:mx-auto'}, 'flex flex-col w-full`}>
			{   login && /*<>
						<Button 
						onClick={() => app.trigger(app.events.REQUEST_LOGIN)}
						basic color='blue'
						className='bg-white hover:bg-is-blue-20 flex items-center cursor-pointer rounded-md text-is-blue text-center my-4 w-full'>
						Login</Button>

						<Button
						onClick={() => app.trigger(app.events.REQUEST_JOIN)}
						basic color='blue'
						className='bg-white hover:bg-is-blue-20 flex items-center cursor-pointer rounded-md text-is-blue text-center my-4 w-full'>
						Create Account</Button></>*/

						<UserArea quiz={true}/>
				||
				navig_data?.[step]?.A?.map((el, i) => 
				<Button
					basic
					color='blue'
					as={el.ext && 'a' || (el.link || el.login && app.user?.user_in) && Link || ''}
					key={i}
					{...(el.ext ? {href: el.value} : {to: el.value})}
					onClick={() => handleClick(el.value, el?.login, el?.name, el.search)}
					className={`${step === el.value ? 'bg-is-blue-150' : 'bg-white'} hover:bg-is-blue-20 flex items-center cursor-pointer rounded-md text-is-blue text-center my-4 w-full`}>
					{el.text}
				</Button>
				)}
			</Form.Group>
		</div>

		{!start && <button onClick={() => setStep('0start')} className="text-white text-center underline underline-offset-4">Start again</button>}

	</div>
}

export default ProdsNavig;



//	------------------------	------------------------	------------------------

	/*search && <Input
	value={srch||''}
	icon='search'  
	iconPosition='left'
	className='w-full lg:max-w-[1074px]'
	placeholder={'Search by medicine name…'}
	onChange={ (e, s) => setSrch(s.value)}
	/>*/